import { get } from "config/infra";
import HomeRepository from "domain/repository/Home";
import { CheckResponse } from "domain/entity/Home";

export default class HomeApi implements HomeRepository {
    async getCheckVerified(): Promise<CheckResponse> {
        return get('/checkverified')
    }
}